export const Amer25Schedule: {
  date: string;
  sessions: {
    time: string;
    title: string;
    speaker: string;
    url?: string;
  }[];
}[] = [
  {
    date: "Sunday, June 8",
    sessions: [
      {
        time: "2:00 PM",
        title: "AI/ML for Network Engineers: A Deep Dive",
        speaker: "Frank Brockners",
        url: "https://www.ciscolive.com/global/learn/session-catalog.html?search=TECETI-2100#/",
      },
    ],
  },
  {
    date: "Monday, June 9",
    sessions: [
      {
        time: "9:30 AM",
        title:
          "Agentic LLMs for Domain-Specific Code Generation and Unified Evaluation",
        speaker: "Nesreen Ahmed",
        url: "https://www.ciscolive.com/global/learn/session-catalog.html?search=IBOETI-2004#/",
      },
      {
        time: "12:30 PM",
        title:
          "Observing and Validating Multi-Agent LLMs in the Wild: You Can’t Fix What You Can’t See​",
        speaker: "Tushar Agrawal, Mayank Gupta",
        url: "https://www.ciscolive.com/global/learn/session-catalog.html?search=PSOETI-1112",
      },
      {
        time: "1:30 PM",
        title: "AI Agents and Agentic Frameworks: An Overview",
        speaker: "Frank Brockners",
        url: "https://www.ciscolive.com/global/learn/session-catalog.html?search=AIHUB-2170#/",
      },
      {
        time: "3:30 PM",
        title:
          "Quantum-Proof Your Security Posture Today: Cisco's Quantum Random Number Generator in Action",
        speaker: "Reza Nejabati",
        url: "https://www.ciscolive.com/global/learn/session-catalog.html?search=WOSETI-1002#/",
      },
      {
        time: "4:00 PM",
        title: "Building Multi-Agent Systems with AGNTCY",
        speaker: "John Parello, Cody Hartsook",
        url: "https://www.ciscolive.com/global/learn/session-catalog.html?search=DEVNET-2028#/",
      },
      {
        time: "5:30 PM",
        title:
          "Applying AI/ML Methods to Diagnose Network Issues Using Telemetry Data",
        speaker: "Frank Brockners",
        url: "https://www.ciscolive.com/global/learn/session-catalog.html?search=AIHUB-2006#/",
      },
    ],
  },
  {
    date: "Tuesday, June 10",
    sessions: [
      {
        time: "11:00 AM",
        title:
          "Quantum Leap: How Cisco's Outshift’s Innovations Helped Save the World in 2030",
        speaker: "Rich Gold",
        url: "https://www.ciscolive.com/global/learn/session-catalog.html?search=WOSETI-1001#/",
      },
      {
        time: "12:00 PM",
        title:
          "Beyond MCP and A2A: How Cisco is building the Internet of Agents with LangChain, CrewAI, Galileo, and MongoDB",
        speaker: "Papi Menon",
        url: "https://www.ciscolive.com/global/learn/session-catalog.html?search=PSOETI-1113#/",
      },
      {
        time: "1:00 PM",
        title:
          "Design Your Quantum-Ready Network: Hands-On with Cisco's Quantum Network Development Kit",
        speaker: "Reza Nejabati",
        url: "https://www.ciscolive.com/global/learn/session-catalog.html?search=WOSETI-1003#/",
      },
      {
        time: "1:30 PM",
        title:
          "The Internet of Agents: Building an Open and Interoperable Agentic AI Ecosystem",
        speaker: "Guillaume De Saint Marc",
        url: "https://www.ciscolive.com/global/learn/session-catalog.html?search=BRKETI-1009#/",
      },
      {
        time: "4:30 PM",
        title: "Inside DevNet: See How We Built AI Agents So You Can Do It Too",
        speaker: "John Parello, Cody Hartsook",
        url: "https://www.ciscolive.com/global/learn/session-catalog.html?search=Inside%20DevNet%3A%20See%20How%20We%20Built%20AI%20Agents%20So%20You%20Can%20Do%20It%20Too%20-%20DEVNET-2322#/",
      },
    ],
  },
  {
    date: "Wednesday, June 11",
    sessions: [
      {
        time: "10:30 AM",
        title:
          "A New Era of Cross-domain Diagnostics with AI and Agentic Systems",
        speaker: "Frank Brockners",
        url: "https://www.ciscolive.com/global/learn/session-catalog.html?search=BRKETI-2172#/",
      },
      {
        time: "1:00 PM",
        title:
          "Agentic AI for Troubleshooting and Change Management: A Glimpse at the Future",
        speaker: "Frank Brockners",
        url: "https://www.ciscolive.com/global/learn/session-catalog.html?search=Agentic%20AI%20for%20Troubleshooting%20and%20Change%20Management%3A%20A%20Glimpse%20at%20the%20Future#/",
      },
      {
        time: "2:30 PM",
        title:
          "Connecting Your Data to LLMs: Identity, Functions and Agents are all you Need",
        speaker: "Guillaume De Saint Marc",
        url: "https://www.ciscolive.com/global/learn/session-catalog.html?search=BRKETI-2411#/",
      },
      {
        time: "3:30 PM",
        title:
          "Beyond Pixels: AI Agents Revolutionizing Video Intelligence Monitoring",
        speaker: "Rich Gold",
        url: "https://www.ciscolive.com/global/learn/session-catalog.html?search=WOSETI-1000#/",
      },
      {
        time: "4:30 PM",
        title:
          "The Quantum Revolution is Closer Than You Think: How Cisco is Building the Future While Securing Today's Networks",
        speaker: "Vijoy Pandey",
        url: "https://www.ciscolive.com/global/learn/session-catalog.html?search=CENETI-1031#/",
      },
    ],
  },
  {
    date: "Thursday, June 12",
    sessions: [
      {
        time: "12:30 PM",
        title:
          "From Agents to Ecosystems: Why Cisco is Building the Internet of Agents",
        speaker: "Papi Menon",
        url: "https://www.ciscolive.com/global/learn/session-catalog.html?search=AIHUB-1950#/",
      },
      {
        time: "1:00 PM",
        title:
          "Agentic AI and NetDevOps: Enabling a New Era of Network Change Validation",
        speaker: "Giovanna Carofiglio, Jordan Auge",
        url: "https://www.ciscolive.com/global/learn/session-catalog.html?search=BRKNWT-2502#/",
      },
      {
        time: "1:00 PM",
        title:
          "Quantum Networking: How Cisco is Building Tomorrow's Infrastructure, Today",
        speaker: "Reza Nejabati",
        url: "https://www.ciscolive.com/global/learn/session-catalog.html?search=BRKETI-2009#/",
      },
    ],
  },
];

export const Amer25PostSchedule: {
  sessions: {
    code: string;
    title: string;
    speaker: string;
    url?: string;
  }[];
}[] = [
  {
    sessions: [
      {
        code: "TECETI-2100",
        title: "AI/ML for Network Engineers: A Deep Dive",
        speaker: "Frank Brockners",
      },
      {
        code: "IBOETI-2004",
        title: "Agentic LLMs for Domain-Specific Code Generation and Unified Evaluation",
        speaker: "Nesreen Ahmed",
      },
      {
        code: "PSOETI-1112",
        title: "Observing and Validating Multi-Agent LLMs in the Wild: You Can’t Fix What You Can’t See​",
        speaker: "Tushar Agrawal, Mayank Gupta",
      },
      {
        code: "AIHUB-2170",
        title: "AI Agents and Agentic Frameworks: An Overview",
        speaker: "Frank Brockners",
      },
      {
        code: "WOSETI-1002",
        title: "Quantum-Proof Your Security Posture Today: Cisco's Quantum Random Number Generator in Action",
        speaker: "Reza Nejabati",
      },
      {
        code: "DEVNET-2028",
        title: "Building Multi-Agent Systems with AGNTCY",
        speaker: "John Parello, Cody Hartsook",
      },
      {
        code: "AIHUB-2006",
        title: "Applying AI/ML Methods to Diagnose Network Issues Using Telemetry Data",
        speaker: "Frank Brockners",
      },
      {
        code: "WOSETI-1001",
        title: "Quantum Leap: How Cisco's Outshift’s Innovations Helped Save the World in 2030",
        speaker: "Rich Gold, Speaker",
      },
      {
        code: "PSOETI-1113",
        title: "Beyond MCP and A2A: How Cisco is building the Internet of Agents with LangChain, CrewAI, Galileo, and MongoDB",
        speaker: "Papi Menon",
      },
      {
        code: "WOSETI-1003",
        title: "Design Your Quantum-Ready Network: Hands-On with Cisco's Quantum Network Development Kit",
        speaker: "Reza Nejabati, Speaker",
      },
      {
        code: "BRKETI-1009",
        title: "The Internet of Agents: Building an Open and Interoperable Agentic AI Ecosystem",
        speaker: "Guillaume De Saint Marc",
      },
      {
        code: "DEVNET-2322",
        title: "Inside DevNet: See How We Built AI Agents So You Can Do It Too",
        speaker: "John Parello, Cody Hartsook",
      },
      {
        code: "BRKETI-2172",
        title: "A New Era of Cross-domain Diagnostics with AI and Agentic Systems",
        speaker: "Frank Brockners",
      },
      {
        code: "DEVNET-2094",
        title: "Agentic AI for Troubleshooting and Change Management: A Glimpse at the Future",
        speaker: "Frank Brockners",
      },
      {
        code: "BRKETI-2411",
        title: "Connecting Your Data to LLMs: Identity, Functions and Agents are all you Need",
        speaker: "Guillaume De Saint Marc",
      },
      {
        code: "WOSETI-1000",
        title: "Beyond Pixels: AI Agents Revolutionizing Video Intelligence Monitoring",
        speaker: "Rich Gold, Speaker",
      },
      {
        code: "CENETI - 1031",
        title: "The Quantum Revolution is Closer Than You Think: How Cisco is Building the Future While Securing Today's Networks",
        speaker: "Vijoy Pandey",
      },
      {
        code: "AIHUB-1950",
        title: "From Agents to Ecosystems: Why Cisco is Building the Internet of Agents",
        speaker: "Papi Menon",
      },
      {
        code: "BRKNWT-2502",
        title: "Agentic AI and NetDevOps: Enabling a New Era of Network Change Validation",
        speaker: "Giovanna Carofiglio",
      },
      {
        code: "BRKETI-2009",
        title: "Quantum Networking: How Cisco is Building Tomorrow's Infrastructure, Today",
        speaker: "Reza Nejabati",
      },
    ],
  },
];
